import { h } from 'preact'
import classNames from 'clsx'

import { getDisplayName } from '../../utils'

export function withClassName(Component, c, displayName) {
  const WrappedComponent = ({ className, ...rest }) => (
    <Component
      {...rest}
      className={classNames(className, c)}
    />
  )

  WrappedComponent.displayName = displayName || `withClassName(${getDisplayName(Component)})`

  return WrappedComponent
}
